import jalaali from "jalaali-js";
import { fixNumbers } from "./utility";
import moment from "moment";

// Converts a Jalali date to a Gregorian date
export const convertToGregorian = ({ year, month: { number: month }, day }) => {
    const jalaliDateObject = jalaali?.jalaaliToDateObject(year, month, day);
    const gregorianDate = new Date(jalaliDateObject?.setHours(0, -jalaliDateObject?.getTimezoneOffset(), 0, 0));
    return gregorianDate;
};

// Converts a Gregorian  date to a Jalali date
export const convertToJalali = date => {
    if (!date) return;

    const [datePart] = date.split("T");
    const [year, month, day] = datePart.split("-").map(Number);

    const gregorianDate = new Date(year, month - 1, day);
    return fixNumbers(new Intl.DateTimeFormat("fa-IR").format(gregorianDate));
};

// Generates an array of dates between the start and end dates, inclusive.
export const generateDateRangeArray = (startDate, endDate) => {
    if (!startDate || !endDate) return [];

    let currentDate = new Date(startDate);
    const dates = [];
    while (currentDate <= new Date(endDate)) {
        dates.push(new Date(currentDate).toISOString().split("T")[0]); // Format as YYYY-MM-DD
        currentDate.setDate(currentDate.getDate() + 1); // Increment by 1 day
    }

    return dates;
};

// Formats a Date object into a string in the format YYYY-MM-DD
export const formatDate = date => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${year}-${month}-${day}`;
};

// Calculates the difference in days between two dates
export function calculateDateDifferenceInDays(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const timeDifference = end.getTime() - start.getTime();
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    return Math.floor(timeDifference / millisecondsInADay);
}

// Calculates the difference in months between two dates
export function calculateMonthDifference(startDate, endDate) {
    if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
        throw new Error("Both arguments must be Date objects");
    }

    const yearDifference = endDate.getFullYear() - startDate.getFullYear();
    const monthDifference = endDate.getMonth() - startDate.getMonth();

    const totalMonthDifference = yearDifference * 12 + monthDifference;

    return Math.max(0, totalMonthDifference);
}

// Calculates the difference in years between two dates.
export function calculateYearDifference(startDate, endDate) {
    if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
        throw new Error("Both arguments must be Date objects");
    }

    const millisecondsDifference = startDate.getTime() - endDate.getTime();
    const millisecondsPerYear = 1000 * 60 * 60 * 24 * 365.25; // Account for leap years

    return Math.abs(millisecondsDifference / millisecondsPerYear);
}

// Checks if a given date is in the past
export function isPastDate(dateToCheck) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const checkDate = new Date(dateToCheck);
    checkDate.setHours(0, 0, 0, 0);

    return checkDate < currentDate;
}

//Formats a date string into Persian (Farsi) format.
export function formatPersianDate(isoDateString, options = {}) {
    if (!isoDateString) return null;

    const [year, month, day] = isoDateString.split("-").map(Number);
    const date = new Date(year, month - 1, day);

    const defaultOptions = {
        day: "numeric",
        month: "long",
        year: "numeric",
        weekday: "long",
    };

    const formatOptions = { ...defaultOptions, ...options };

    return new Intl.DateTimeFormat("fa-IR", formatOptions).format(date);
}
//Formats a date string into Gregorian format.
export function formatGregorianDate(start, end, format) {
    const startDate = moment(start).format(format);
    const endDate = end ? `to ${moment(end).format(format)}` : "";
    return `${startDate} ${endDate} `;
}

export function formatDateWithArabicMonth(date) {
    const arabicMonthNames = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];

    const d = new Date(date);
    const day = d.getDate().toString().padStart(2);
    const month = arabicMonthNames[d.getMonth()];

    return `${day} ${month}`;
}
